<template>
  <div>
    <h1 class="page_title">Бонусная программа</h1>
    <row>
      <grid-item xs="12" md="4" mb="15px">
        <white-bg padding="25px 30px">
          <h4>У вас на счете</h4>
          <div style="display: flex">
            <div class="score">
              <div class="points">{{ getUser.points || 0 }}</div>
              <h2> баллов</h2>
            </div>
            <div class="score" style="margin-left: 20px" v-if="getUser.hours">
              <div class="points">{{ getUser.hours || 20 }}</div>
              <h2> часов</h2>
            </div>
          </div>
          <row v-if="getUser.personal_code">
            <grid-item md="10" xs="9" style="padding-right: 5px">
              <custom-input :value="registerUrl" :disabled="true"/>
            </grid-item>
            <grid-item md="2" xs="2" style="padding: 0">
              <button
                style="margin-top: 0; position: relative"
                v-clipboard="registerUrl"
                v-clipboard:success="() => $toast.success('Скопировано!')"
              >
                <img src="@/assets/images/icons/copy.svg" alt="copy" width="24px" style="position: absolute; top: calc(50% - 12px); left: calc(50% - 12px)">
              </button>
            </grid-item>
          </row>
        </white-bg>
        <white-bg padding="25px 30px" style="margin-top: 15px;">
          <h3>Ваши рефералы</h3>
          <RefList :referrals="referrals"/>
        </white-bg>
      </grid-item>
      <grid-item xs="12" md="4">
        <white-bg :style="{'min-height': !bonuses ? '350px': 'auto'}" padding="25px 30px">
          <preload-content :loading="!bonuses">
            <template v-if="bonuses">
              <h3>История событий</h3>
              <template v-if="bonuses.length">
                <div class="store" :key="idx" v-for="(eventsItem, idx) in bonuses">
                  <div class="store__body">
                    <div class="store__body-item">
                      <div class="store__body-item-name">
                        {{ eventsItem.text ? eventsItem.text : eventsItem.description }}
                      </div>
                      <div class="store__body-item-ball" :class="{profit: isPlusType(eventsItem.bonus)}">
                        {{ isPlusType(eventsItem.bonus) ? '+' : '-' }}{{ eventsItem.user_sum }}
                      </div>
                    </div>
                    <div class="store__body-date">
                      <div v-if="eventsItem.created_at">
                        {{ eventsItem.created_at }}
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <div v-else>
                Список пуст
              </div>
              <div class="bonuses__more" v-if="bonusesPage !== bonusesLastPage">
                <button @click="loadBonuses(true)">Показать больше</button>
              </div>
            </template>
          </preload-content>
        </white-bg>
      </grid-item>
    </row>
  </div>
</template>

<script>
import Vue from 'vue';
import Clipboard from 'v-clipboard';

import preloadContent from '../../../components/ui/preload-content';
import WhiteBg from '../../../components/ui/white-bg'
import GridItem from '../../../components/grid/GridItem'
import Row from '../../../components/grid/Row'
import {mapGetters, mapMutations} from 'vuex'
import CustomInput from "@/components/ui/inputs/custom-input";
import RefList from "@/pages/Cabinet/Master/bonus/referrals_list";

Vue.use(Clipboard);

export default {
  name: 'Bonus',
  components: {RefList, CustomInput, WhiteBg, GridItem, Row, preloadContent},
  data() {
    return {
      bonuses: null,
      referrals: [],
      bonusesPage: 1,
      referralsPage: 1,
      bonusesLastPage: 1,
      referralsLastPage: 1,
    }
  },
  computed: {
    ...mapGetters(['getUser', 'getBonus']),
    registerUrl() {
      return window.location.origin + this.$router.resolve({name: 'register.partner', params: {code: this.getUser.personal_code}}).href;
    }
  },
  mounted() {
    this.loadBonuses();
    this.loadReferrals();
    if (this.getBonus) this.removeNotSeeBonuses();
  },
  methods: {
    ...mapMutations(['setBonus']),
    removeNotSeeBonuses() {
      this.$api.notification.bonus().then(() => this.setBonus(false));
    },
    isPlusType(type) {
      if (!type) return type;
      return type.type === 'in';
    },
    setBonuses(data, more = false) {
      more ? data.data.map((val) => this.bonuses.push(val)) : this.bonuses = data.data;
      this.bonusesPage = data.meta.current_page;
      this.bonusesLastPage = data.meta.last_page;
    },
    loadBonuses(more = false) {
      if (more) this.bonusesPage += 1;
      return this.$api.master.bonus.list(this.bonusesPage).then((data) => this.setBonuses(data, more));
    },
    loadReferrals() {
      this.$api.master.bonus.referrals(this.referralsPage)
        .then((data) => {
          this.referrals = data.data
          this.referralsPage = data.meta.current_page;
          this.referralsLastPage = data.meta.last_page;
        })
    }
  }
}
</script>

<style scoped lang="scss">
h1 {
  display: none;
}

.points {
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  color: #383838;
  margin-bottom: 5px;
  padding-top: 0;
}

h2 {
  margin: -15px 0 0 5px;
  padding-bottom: 10px;
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  color: #383838;
}

h3 {
  margin-bottom: 10px;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  color: #383838;
  font-family: "Open Sans", sans-serif;
}

h4 {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  color: #808080;
  font-family: "Open Sans", sans-serif;
  margin-bottom: 5px;
}

button {
  font-family: "Open Sans", sans-serif;
  width: 100%;
  height: 50px;
  border: none;
  background: #DBBFA7;
  border-radius: 5px;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #383838;
  margin-top: 15px;
}

.score {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
}

.store {
  padding-top: 10px;
  margin: 0 -30px 0 -30px;

  &__body {
    margin: 0 30px 0 30px;

    &-item {
      display: flex;
      align-items: center;
      justify-content: space-between;

      &-name {
        font-family: "Open Sans", sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
        color: #383838;
      }

      &-ball {
        font-family: "Open Sans", sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        text-align: right;

        &.profit {
          color: #0F8A84;
        }
      }
    }

    &-date {
      font-family: "Open Sans", sans-serif;
      display: flex;
      flex-wrap: wrap;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 20px;
      color: #808080;
      padding-bottom: 5px;
    }
  }
}

.bonuses {
  &__more {
    button {
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
      background-color: transparent;
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: #B9765B;

      &:after {
        content: '';
        width: 20px;
        height: 20px;
        margin-left: 5px;
        background-image: url("../../../assets/images/icons/chevron-down.svg");
        background-position: center center;
        background-repeat: no-repeat;
      }
    }
  }
}

@media screen and (max-width: 991px) {
  h1 {
    display: block;
    font-size: 24px;
    line-height: 1.33;
    color: #383838;
    margin-bottom: 15px;
    margin-top: -10px;
    padding-top: 0;
  }

  .whiteBg {
    padding: 15px !important;
  }
}
</style>
